import { QUOTE_CLASSIFICATION } from 'src/constants/common';

export const classOptions = [
    {
        label: 'LTL',
        value: QUOTE_CLASSIFICATION.LTL,
    },
    {
        label: 'FTL',
        value: QUOTE_CLASSIFICATION.FTL,
    },
];
